export default "__VITE_ASSET__Duse_wNm__ 720w";